import { render, staticRenderFns } from "./testzone.vue?vue&type=template&id=53891bd1&"
import script from "./testzone.vue?vue&type=script&lang=js&"
export * from "./testzone.vue?vue&type=script&lang=js&"
import style0 from "./testzone.vue?vue&type=style&index=0&id=53891bd1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports